import { render, staticRenderFns } from "./ActivationModal.vue?vue&type=template&id=8331413a&"
import script from "./ActivationModal.vue?vue&type=script&lang=js&"
export * from "./ActivationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports